var React = require('react');

function IconSocialLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.67 4.73a3.06 3.06 0 013.06-3.06h30.54a3.06 3.06 0 013.06 3.06v30.54a3.06 3.06 0 01-3.06 3.06H4.73a3.06 3.06 0 01-3.06-3.06V4.73zm14.51 10.92h4.96v2.49c.72-1.43 2.55-2.72 5.31-2.72 5.28 0 6.53 2.85 6.53 8.09v9.7h-5.34v-8.5c0-2.99-.72-4.67-2.54-4.67-2.52 0-3.57 1.81-3.57 4.66v8.51h-5.35V15.65zM7.01 32.99h5.35V15.41H7.01v17.56zm6.12-23.3a3.44 3.44 0 11-6.88.15 3.44 3.44 0 016.88-.15z","fill":"#0072B1"}));
}

IconSocialLinkedin.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 40 40"};

module.exports = IconSocialLinkedin;

IconSocialLinkedin.default = IconSocialLinkedin;
